export const ResetPasswordErrorCodes = {
  PASSWORD_RESET_ATTEMPT_LIMIT_REACHED: "PASSWORD_RESET_ATTEMPT_LIMIT_REACHED",
};
